import {SecurityContext} from '@angular/core';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';

/** Basic PrimeNG file inputs allocate previews even though no preview is rendered. */
export function releaseFileUploadPreview(file: File, sanitizer: DomSanitizer): void {
  const previewFile = file as File & {objectURL?: SafeUrl};
  if (!previewFile.objectURL) { return; }
  const url = sanitizer.sanitize(SecurityContext.URL, previewFile.objectURL);
  if (url?.startsWith('blob:')) { URL.revokeObjectURL(url); }
  delete previewFile.objectURL;
}
